// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};
  
    SearchInput.prototype.render = function() {
      var queryValue = Utils.getParam(Globals.searchTermKey);
      this.$element.val(queryValue)
      .addClass(Class.searchBox)
      .attr('id', this.id)
      .attr('data-search-box', this.id)
      .attr('aria-live', 'assertive')
      .attr('aria-label', Labels.suggestion.searchBoxPlaceholder)
      .attr('placeholder', boostPFSThemeConfig.label.input_placeholder);
      this.isRendered = true;
    }
})();